import { useContext, createContext } from "react";

type WalletModalContextType = {
  isOpen: boolean;
  openWalletModal: () => void;
  closeWalletModal: () => void;
};

export const WalletModalContext = createContext<WalletModalContextType | null>(
  null,
);

export function useWalletModal() {
  const context = useContext(WalletModalContext);
  if (!context) {
    throw new Error("useWalletModal must be used within WalletModalProvider");
  }
  return context;
}
